import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import Translation from '../components/common/Translation';
import '../assets/styles/AdminLogin.scss';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();
  const { language } = useLanguage();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch('/api/admin/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'invalidCredentials');
      }

      // Store admin token in localStorage
      localStorage.setItem('adminToken', data.token);
      localStorage.setItem('isAdmin', 'true');
      
      // Redirect to admin dashboard
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <h1><Translation textKey="adminLogin" /></h1>
            <p><Translation textKey="adminLoginSubtitle" /></p>
          </div>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error === 'invalidCredentials' ? <Translation textKey="invalidCredentials" /> : error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="form-group">
              <label htmlFor="username">
                <FontAwesomeIcon icon={faUser} /> <Translation textKey="username" />
              </label>
              <input
                type="text"
                id="username"
                name="username"
                className="form-control"
                placeholder={language === 'en' ? 'Enter your username' : 'أدخل اسم المستخدم'}
                value={formData.username}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">
                <FontAwesomeIcon icon={faLock} /> <Translation textKey="password" />
              </label>
              <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                placeholder={language === 'en' ? 'Enter your password' : 'أدخل كلمة المرور'}
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <button
              type="submit"
              className={`btn btn-admin-login ${isLoading ? 'loading' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="spinner"></span>
              ) : (
                <>
                  <Translation textKey="login" /> <FontAwesomeIcon icon={faArrowRight} />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
